(function () {
  function revealInit() {
    var root = document.querySelectorAll('.nogu-serotonin .reveal');
    if (!root.length) return;
    if (!('IntersectionObserver' in window)) {
      root.forEach(function (el) {
        el.classList.add('on');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('on');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    root.forEach(function (el) {
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealInit);
  } else {
    revealInit();
  }
})();
